<script setup lang="ts">
interface Props {
  text: string
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <div v-bind="$attrs">
    <div class="relative">
      <div class="flex items-center absolute inset-0">
        <div class="border-t border-gray-200 dark:border-gray-500 w-full"></div>
      </div>
      <div v-if="text" class="relative flex items-center">
        <span class="font-medium text-xs bg-white dark:bg-black dark:text-gray-500 pe-1.5">
          {{ text }}
        </span>
      </div>
    </div>
  </div>
</template>
